import React from "react"
import { notifications } from "@mantine/notifications"

import { ErrorIcon } from "@/components"

const notificationStyles = (theme) => ({
    description: {
        color: theme.colors.gray[7],
    },
})

export const errors = (message: string) => {
    notifications.show({
        id: "social-media-errors",
        title: "Failed to save Social Media",
        message,
        autoClose: false,
        color: "red.0",
        icon: <ErrorIcon />,
        closeButtonProps: { "aria-label": "Dismiss notification" },
        styles: notificationStyles,
    })
}

export const failure = () => {
    notifications.show({
        id: "social-media-failure",
        title: "Failed to save Social Media",
        message: "Something went wrong",
        autoClose: false,
        color: "red.0",
        icon: <ErrorIcon />,
        closeButtonProps: { "aria-label": "Dismiss notification" },
        styles: notificationStyles,
    })
}
